import { useState, useCallback, useEffect } from 'react';
import { SiteItemModel } from '../../sites/models/site-item.model';

// Cache global pour les sites filtrés
let sitesCache: SiteItemModel[] | null = null;

// Fonction de filtrage des sites selon les critères métier
const filterSites = (sites: SiteItemModel[]): SiteItemModel[] => {
  return sites.filter(site => 
    !site.isExported && 
    site.numberOfAnnotations > 0
  );
};

export const useSitesCache = (sitesToPopulate?: SiteItemModel[] | null) => {
  const [siteList, setSiteList] = useState<SiteItemModel[] | null>(sitesCache);

  // Fonction pour alimenter le cache depuis l'extérieur (utilisée par use-site-list)
  const populateCache = useCallback((sites: SiteItemModel[]) => {
    // Filtrer les sites avant de les mettre en cache
    const filteredSites = filterSites(sites);
    sitesCache = filteredSites;
    setSiteList(filteredSites);
  }, []);

  // Fonction pour récupérer les sites du cache
  const getSitesFromCache = useCallback(() => {
    if (sitesCache) {
      setSiteList(sitesCache);
      return sitesCache;
    }
    return null;
  }, []);

  // Fonction pour vider le cache (utile pour forcer le rechargement)
  const clearCache = useCallback(() => {
    sitesCache = null;
    setSiteList(null);
  }, []);

  // Alimenter automatiquement le cache si des sites sont fournis
  useEffect(() => {
    if (sitesToPopulate) {
      populateCache(sitesToPopulate);
    }
  }, [sitesToPopulate, populateCache]);

  return {
    siteList,
    populateCache,
    getSitesFromCache,
    clearCache,
    isCached: sitesCache !== null
  };
}; 